module.exports = __webpack_public_path__ + "static/media/logo-short.7f3bc062.png";